import { render, staticRenderFns } from "./NumberHeader.vue?vue&type=template&id=b506b382&scoped=true"
import script from "./NumberHeader.vue?vue&type=script&lang=js"
export * from "./NumberHeader.vue?vue&type=script&lang=js"
import style0 from "./NumberHeader.vue?vue&type=style&index=0&id=b506b382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b506b382",
  null
  
)

export default component.exports